/*========================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

define(["jquery", "underscore"], function ($, _) {

  var Role = function () {
    this.initialize.apply(this, arguments);
  };

  Role.prototype.initialize = function (containerEl, options) {
    options = options || {};

    this.$containerEl = $(containerEl);
    this.selector = options.selector;
    this.handlers = options.handlers;

    this.$containerEl.on("mousedown.mb-role", this.selector, _.bind(this.mousedown, this));
    this.$containerEl.on("focusin.mb-role", _.bind(this.focusin, this));
  };
  
  Role.prototype.mousedown = function (e) {
    // TODO: get selector from handler
    var target = e.currentTarget,
        role = target.getAttribute("role");

    if (this.handlers[role]) {
      $(target).find("button[tabindex!=0],a[tabindex!=0],[role=tab][tabindex!=0]").attr("tabindex", "-1");
    }
  };

  Role.prototype.focusin = function (e) {
    var that = this,
        roleEls = _.toArray($(e.target).parents(this.selector)),
        found = false,
        foundHandler = false;

    // deal with nested applications
    if (!e.mbRoleHandled) {
      if ($(e.target).is(this.selector)) {
        roleEls.splice(0, 0, e.target);
      }

      _.each(roleEls, function (roleEl) {
          if (found) return;

          var role = roleEl.getAttribute("role"),
              handler = that.handlers[role],
              same = that.$el && that.$el[0] == roleEl;

          foundHandler = foundHandler || !!handler;

          if (handler) {
            if (!same) {
              if (that.$el) {
                that.leave(that.$el, e);
                that.$el.attr("tabindex", "0");
              }
              that.$el = $(roleEl);
              that.$el.attr("tabindex", "-1");
              that.update(that.$el, e, handler);
            }
            found = true;
          }
      });

      e.mbRoleHandled = foundHandler;
    }

    if (!foundHandler && that.$el) {
      that.leave(that.$el, e);
      that.$el.attr("tabindex", "0");
      delete that.$el;
    }
  };

  Role.prototype.update = function ($el, e, handler) {
    this.$el.attr("tabindex", -1);
    this.handler = handler;
    this.handler.update.apply(this.handler, arguments);
  };

  Role.prototype.leave = function () {
    this.handler && this.handler.destroy();
    delete this.handler;
  };

  Role.prototype.destroy = function () {
    this.$containerEl && this.$containerEl.off(".mb-role");

    delete this.$containerEl;
    delete this.selector;
    delete this.handlers;
  };

  return Role;
});
